module.exports = __webpack_public_path__ + "assets/images/pages/job/image-detail-4.png?016e2f14";